<template lang="pug">
.section
  .section-header
    h1 {{ $t("ui.social_platform") }}
  .section-body
    .row
      .col-12
        .card.mb-0
          .card-header
            .row
              .form-group.col-12
                .d-flex
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t('ui.status') }}
                    b-input-group-text(slot="append")
                      label.custom-switch
                        input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="spStatus" @change="getSocialPlatformList()")
                        span.custom-switch-indicator
                  SubmitButton.ml-3(
                    icon="fa fa-search"
                    :loading="loading"
                    :text="$t('ui.search')"
                    type="button"
                    @click="getSocialPlatformList()"
                    variant="primary"
                    size="sm"
                  )
              .form-group.col-12(v-if="isAdmin && isEditAccess")
                b-button(v-b-modal.addSocialPlatform type="button" variant="info" size="sm")
                  i.fa.fa-plus
                  span.ml-1 {{ $t("ui.combine.add_platform") }}
          .card-body
            .row
              .col-12 
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                    thead.thead-light
                      tr
                        th.text-center(width="5%")
                          span #
                        th(width="15%")
                          span(:title="$t('ui.platform')") {{ $t('ui.platform') }}
                        th.text-right(width="15%")
                          span(:title="$t('ui.created_date')") {{ $t('ui.created_date') }}
                        th.text-right(width="15%")
                          span(:title="$t('ui.modified_date')") {{ $t('ui.modified_date') }}
                        th.text-center(width="7%")
                          span(:title="$t('ui.status')") {{ $t("ui.status") }}
                        th.text-center(width="10%" v-if="isAdmin && isEditAccess")
                          span(:title="$t('ui.action')") {{ $t("ui.action") }}
                    tbody.clusterize-content
                      tr(v-if="socialList.length == 0")
                        td(:colspan="isAdmin && isEditAccess ? '6' : '5'").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in socialList")
                        td.text-center
                          span(:title="index + 1") {{ index + 1 }}
                        td
                          span(:title="item.social_platform") {{ item.social_platform }}
                        td.text-right
                          span(:title="item.created_by") {{ item.created_by }}
                          br
                          span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
                        td.text-right
                          span(:title="item.modified_by") {{ item.modified_by ? item.modified_by : "-" }}
                          br
                          span(:title="$moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss')") {{ item.modified_date ? $moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss') : "-" }}
                        td.text-center
                          div.d-flex.justify-content-center.align-items-center
                            label.custom-switch
                              input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="item.status" @change="!isAdmin ? null : changedStatus(item, $event)" :disabled="!isAdmin || !isEditAccess")
                              span.custom-switch-indicator
                        td.actions.text-center(v-if="isAdmin && isEditAccess")
                          span
                            a.fa.fa-edit.btn.btn-ssm.btn-primary(href="javascript:void(0)" @click="onEditSocialPlatform(item)" :title="$t('ui.edit')")
    addsocialplatform(@clicked="addSocialPlatform" @failed="handleFailed")
    editsocialplatform(ref="editsocialplatform" :item="editSelectedSocialPlatform" @clicked="afterEditSocialPlatform" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import { required, minLength, maxLength, alphaNum, integer, email, helpers, decimal, requiredIf } from "vuelidate/lib/validators";
import ValidateResult from "@/library/ValidateResult";
import addsocialplatform from "@/components/globalsetting/addSocialPlatform.vue";
import editsocialplatform from "@/components/globalsetting/editSocialPlatform.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    ValidateResult,
    addsocialplatform,
    editsocialplatform
  },
  data: () => ({
    loading: false,
    socialList: [],
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    spStatus: true,
    editSelectedSocialPlatform: null
  }),
  computed: {
    getAccountId() {
      return this.$store.getters.accountId;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_socialplatformlookup");
    }
  },
  mounted: function() {
    this.getSocialPlatformList();
  },
  methods: {
    changedStatus: function(item, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_social_platform_status_confirm", { name: item.social_platform }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmStatus(item, eventStatus.srcElement.checked);
          } else {
            eventStatus.srcElement.checked = !item.status;
            item.status = !item.status;
          }
        });
    },
    confirmStatus: function(item, status) {
      let url = config.socialPlatformLookupStatusUpdateUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        social_platform: item.social_platform,
        new_status: status
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
              this.getSocialPlatformList();
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    addSocialPlatform: function() {
      this.getSocialPlatformList();

      this.$helpers.showDialog(this.$t("ui.combine.add_platform"), this.$t("message.success"), "success");
    },
    onEditSocialPlatform(e) {
      this.editSelectedSocialPlatform = e;
      this.$refs.editsocialplatform.$refs.editSocialPlatform.show();
    },
    afterEditSocialPlatform: function() {
      this.getSocialPlatformList();
      this.$helpers.showDialog(this.$t("ui.combine.edit_platform"), this.$t("message.success"), "success");
    },
    getSocialPlatformList: function() {
      let url = config.socialPlatformLookupListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        platform_status: this.spStatus,
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.socialList = response.data.dt;
                // if (response.data.dt.length > 0) {
                //   this.socialList = response.data.dt;
                // }
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>